import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useMemo } from 'react'
import decodeJwt from 'jwt-decode'

export const useGetOrgId = (): string => {
  const { org, token } = useAuthState()

  return useMemo(() => {
    if (org?.orgId) {
      return org.orgId
    }

    if (!token) {
      return ''
    }

    try {
      return decodeJwt<{ tenantId: string }>(token)?.tenantId || ''
    } catch {
      return ''
    }
  }, [org?.orgId, token])
}
